import * as tslib_1 from "tslib";
import { ConfigService } from '../services/config.service';
import * as i0 from "@angular/core";
import * as i1 from "../services/config.service";
export class FeedGuard {
    constructor(configService) {
        this.configService = configService;
    }
    canActivate() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.configService.getInitialInfo().then((response) => {
                return response;
            });
            let modulesEnabled = yield this.configService.company_info.modules_enabled;
            if (modulesEnabled) {
                if (modulesEnabled.includes('SOCIAL')) {
                    return true;
                }
                else {
                    return false;
                }
            }
        });
    }
}
FeedGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FeedGuard_Factory() { return new FeedGuard(i0.ɵɵinject(i1.ConfigService)); }, token: FeedGuard, providedIn: "root" });
